import { z } from 'zod/v4'

// ***
// SCHEMAS
// ***

export const SubsidySchema = z.object({
  id: z.string(),
  name: z.string(),
})

export const ClubLegacySchema = z.object({
  companyName: z.string(),
  enabledFeatures: z.array(z.unknown()),
  id: z.string(),
  image: z.string(),
  name: z.string(),
  shortname: z.string(),
  privacy: z.object({
    basicInfo: z.string(),
    custom: z.boolean(),
    customUrl: z.union([z.string(), z.boolean()]),
    url: z.string(),
    version: z.number(),
  }).nullable(),
})

export const UserDataLegacySchema = z.object({
  clubName: z.string().optional(),
  clubLogo: z.string().optional(),
  name: z.string().optional(),
  lastname: z.string().optional(),
  subsidies: z.array(SubsidySchema).optional(),
  email: z.string().nullable().optional(),
  phone: z.string().optional(),
  id: z.string().optional(),
})

export const ClubGroupLegacySchema = z.object({
  club: ClubLegacySchema,
  persons: z.array(z.object({
    club: ClubLegacySchema,
    dni: z.string().nullable(),
    email: z.string().nullable(),
    id: z.string(),
    enabled: z.boolean(),
    name: z.string(),
    phone: z.string(),
    qrIdentifier: z.string(),
    surname: z.string(),
    terms: z.union([z.string(), z.record(z.string(), z.unknown())]).nullable(),
    type: z.string(),
    panelAccess: z.boolean().optional(),
    roles: z.unknown(),
    appliedClub: z.string().nullable().optional(),
    applicant: z.boolean().nullable().optional(),
    subsidies: z.array(SubsidySchema).optional(),
  })),
})

// ***
// EXPORTED TYPES
// ***

export type Subsidy = z.infer<typeof SubsidySchema>
export type ClubLegacy = z.infer<typeof ClubLegacySchema>
export type UserDataLegacy = z.infer<typeof UserDataLegacySchema>
export type ClubGroupLegacy = z.infer<typeof ClubGroupLegacySchema>
